import React, { Component } from 'react'
import { connect } from 'react-redux'

import General from '../components/SolicitudHoteles/General'
import Cotizacion from '../components/SolicitudHoteles/Cotizacion'
import Aprobaciones from '../components/SolicitudHoteles/Aprobaciones'
import Reservaciones from '../components/SolicitudHoteles/Reservaciones'
import Cierre from '../components/SolicitudHoteles/Cierre'
import Cancelacion from '../components/SolicitudHoteles/Cancelacion'


import BoxButton from '../components/Layout/BoxButton'
import ButtonStrip from '../components/Layout/ButtonStrip'


import {
    canmbiarResponsable,
    showModalConfirmarAccion
} from '../actions/common'




import {
    getSolicitud,
    updateSolicitudHoteles,
    registerReservaciones,
    registerReservacionesExpirados,
    registerCancelacion,
    solicitarCancelación
} from '../actions/solicitudhoteles'

import history from '../utils/history'

import { isAllowedToViewComponent } from '../utils/helpers'


class SolicitudHoteles extends Component {

	constructor(props) {
        super(props)

		this.state = {
			tabs: [
                { id: 0, caption: 'Solicitud', component: <General/>, estado: 1 },
                { id: 1, caption: 'Cotización', component: <Cotizacion/>, estado: 2 },
                { id: 2, caption: 'Aprobación', component: <Aprobaciones/>, estado: 3 },
                { id: 3, caption: 'Reservaciones', component: <Reservaciones/>, estado: 4 },
                { id: 4, caption: 'Cierre', component: <Cierre/>, estado: 6 },
                { id: 5, caption: 'Cancelacion', component: <Cancelacion/>, estado: 0 },
			],
			selected: 0
        }


    }

    componentWillMount() {
        if (this.props.match.params.id) {
            this.props.getSolicitud(this.props.match.params.id)
            const params = new URLSearchParams(this.props.location.search);
            if (params.has("aprobacion")) {
                this.setState({selected: 2})
            }
        } else {
            history.push(window.FOLDER + '/solicitudes/abiertas')
        }
    }

	selectTab = (e, tab) => {
		e.preventDefault()
		this.setState({ selected: tab })
    }

    cancel = () => {
        this.props.showModalConfirmarAccion(true, `¿Está seguro que desea cancelar la solicitud?`, () => { this.props.showModalConfirmarAccion(false); this.props.registerCancelacion()})
    }

    getSolicitudRechazada = () => {
        let contador = 0

        if (this.props.solicitud.get('cotizaciones')) {
            if (this.props.solicitud.get('cotizaciones').count() == 0) return false
            this.props.solicitud.get('cotizaciones').map(cotizacion => {
                if (cotizacion.get('aprobaciones')) {
                    const aprobaciones = cotizacion.get('aprobaciones').count()
                    const rechazadas = cotizacion.get('aprobaciones').filter(x => x.get('estado') == 0).count();
                    if (aprobaciones == rechazadas) contador++

                }
            })

            return contador == this.props.solicitud.get('cotizaciones').count()
        }

        return false

    }



    getSolicitudAprobadas = () => {

        let contador = 0

        if (this.props.solicitud.get('cotizaciones')) {
            contador = this.props.solicitud.get('cotizaciones').reduce((cont, cotizacion) => {
                if (cotizacion.get('aprobaciones')) {
                    const aprobados = cotizacion.get('aprobaciones').filter(aprobacion => aprobacion.get('estado') == 2).count()
                    if (aprobados > 0) {
                        cont++
                    }
                }
                return cont
            }, 0)
        }
        return contador > 0

    }



    getEstadoAprobacion = () => {
        if (this.getSolicitudRechazada()) return 0
        if (this.getSolicitudAprobadas()) return 2
        return 1
    }


    getPagoRealizado = () => {

        let contador = 0

        if (this.props.solicitud.get('hotel')) {
            contador = this.props.solicitud.getIn(['hotel', 'reservaciones']).reduce((cont, reservacion) => {
                if (reservacion.get('valor_pagado') > 0) {
                    cont++
                }
                return cont
            }, 0)
        }

        return contador > 0

    }

	render() {
		const { tabs, selected } = this.state
        const { estado, solicitud, btnRComprasDisabled, user , btnSaveDisabled} = this.props

        //const esResponsableCompras = solicitud.getIn(['responsable_compras', 'id']) == user.get('id')

        const readOnly = !isAllowedToViewComponent('responsable_compras', solicitud)
        const onlySolicitante = isAllowedToViewComponent('solicitante', solicitud)
        let boxActions;

        boxActions = [
            estado === 1 ? (
                <BoxButton key="ba[0][1]" name="floppy-o" onClick={ () => this.props.updateSolicitudHoteles() } title="Actualizar solicitud" disabled={ estado !== 1 || selected !== 0} />
            ):(
                <BoxButton key="ba[0][1]" name="floppy-o" onClick={ () => this.props.updateSolicitudHoteles() } title="Actualizar solicitud" disabled={ (estado !== 2 || selected !== 1 || readOnly)} />
            ),

            <BoxButton key="ba[0][2]" name="user" onClick={ () => this.props.canmbiarResponsable(solicitud, 'ACTUALIZAR_SOLICITUD_HOTELES') } title="Cambiar responsable" disabled={ btnRComprasDisabled || selected !== 0 || readOnly } />,
            <BoxButton key="ba[0][3]" name="ticket" onClick={ () => this.props.registerReservaciones() } title="Registrar reservación" disabled={ estado !== 4 || selected !== 3 || readOnly } />,
            <BoxButton key="ba[0][4]" name="check" onClick={ () => this.props.registerReservacionesExpirados() } title="Actualizar reservaciones" disabled={ (estado !== 6 || selected !== 4 || !onlySolicitante ) } />,
            <BoxButton key="ba[0][5]" name="ban" onClick={ () => this.cancel() } title="Aprobar cancelación solicitud" disabled={ selected !== 5 || estado == 0 } />
            // !esResponsableCompras ? <BoxButton key="ba[0][5]" name="ban" onClick={ () => this.cancel() } title="Aprobar cancelación solicitud" disabled={ selected !== 5 || estado == 0 } />:null,
            // esResponsableCompras ? <BoxButton key="ba[0][5]" name="ban" onClick={ () => this.props.solicitarCancelación() } title="Solicitar cancelación solicitud" disabled={ selected !== 5 || estado == 0 } />: null,
        ]

		return (
            <div className="row" style={{ height: '100%', overflowX: 'hidden' }}>
                <div className="col-md-12" style={{ height: '100%' }}>
                    <div className="nav-container">
                        <div className="nav-tabs-section">
                            <ul className="nav-tabs-tabs">
                                {
                                    tabs.filter(x => x.estado <= estado || estado == 0).map(x => {

                                        if (estado == 0) {
                                            if (this.getEstadoAprobacion() == 1 && x.id == 2) return null
                                            if (!this.getPagoRealizado() && x.id == 3) return null
                                            if (!this.getPagoRealizado() && x.id == 4) return null
                                        }

                                        if (estado == 1 && x.id == 5) return null
                                        if (estado == 7 && x.id == 5) return null
                                        if (this.getEstadoAprobacion() == 0 && x.id == 5) return null

                                        return (
                                            <li key={ `li01[${x.id}]` } className={ selected === x.id ? 'active' : '' }>
                                                <a onClick={ (e) => this.selectTab(e, x.id) }>{ x.caption }</a>
                                            </li>
                                        )


                                    })
                                }
                            </ul>
                        </div>
                        <div className="nav-main-section">
                            <div className="">
                                <ButtonStrip actions={ boxActions } />
                            </div>
                            <div className="nav-main-section-scrollable">
                                { tabs[selected].component }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
		)
	}
}

function mapStateToProps(state) {
    return {
        btnSaveDisabled: state.solicitudhoteles.get('btnSaveDisabled'),
        btnRComprasDisabled: state.solicitudhoteles.get('btnRComprasDisabled'),
        estado: state.solicitudhoteles.get('estado'),
        solicitud: state.solicitudhoteles.get('solicitud'),
        user: state.common.get('user')
    }
}





function mapDispatchToProps(dispatch) {
    return {
        getSolicitud: (id) => dispatch(getSolicitud(id)),
        updateSolicitudHoteles: () => dispatch(updateSolicitudHoteles()),
        registerReservaciones: () => dispatch(registerReservaciones()),
        registerReservacionesExpirados: () => dispatch(registerReservacionesExpirados()),
        canmbiarResponsable: (solicitud, type) => dispatch(canmbiarResponsable(solicitud, type)),
        registerCancelacion: () => dispatch(registerCancelacion()),
        solicitarCancelación: () => dispatch(solicitarCancelación()),
        showModalConfirmarAccion: (show, message, action) => dispatch(showModalConfirmarAccion(show, message, action)),
    }
}



export default connect(mapStateToProps, mapDispatchToProps)(SolicitudHoteles)



// WEBPACK FOOTER //
// ./src/containers/SolicitudHoteles.jsx